import { Component } from '@angular/core';
import { RegistrationApiService } from 'src/app/api/registration/registrationApiService';
import { RegistrationsImportResponse } from 'src/app/api/registration/registrationsImportResponse';
import { mapImportErrors } from 'src/app/utils/error-utils';

@Component({
    selector: 'app-import-registrations',
    templateUrl: './import-registrations.component.html',
    styleUrls: ['./import-registrations.component.css'],
    standalone: false
})
export class ImportRegistrationsComponent {
  validationInProgress: boolean = false;
  uploadInProgress: boolean = false;
  errors: string[] = [];
  uploadResponse: RegistrationsImportResponse | null = null; //server response - for debugging
  canUpload: boolean = false;
  formData: FormData | null = null;
  uploadFinished: boolean = false;
  fileName: string = '';

  constructor(
    private registrationApiService: RegistrationApiService
  ) { }

  fileInputChange(fileInputEvent: any) {
    this.validationInProgress = true;
    this.canUpload = false;
    this.errors = [];
    this.uploadResponse = null;
    this.uploadFinished = false;
    this.fileName = fileInputEvent.target.files[0].name;

    this.formData = new FormData();
    this.formData.append('file', fileInputEvent.target.files[0]);
    this.formData.append('shouldValidateOnly', 'true');

    this.registrationApiService.importRegistrations(this.formData)
      .subscribe({
          next: response => {
            this.validationInProgress = false;
            this.errors = [];
            this.uploadResponse = response;
            this.canUpload = true;
          },
          error: error => {
            this.validationInProgress = false;
            this.errors = mapImportErrors(error.error.Message, error.error.Errors);
            this.canUpload = false;
            this.uploadResponse = error;
          }
        });
  }

  executeUpload() {
    if(this.formData == null) {
      console.error('No file selected');
      return;
    }

    this.formData.delete('shouldValidateOnly');
    this.formData.append('shouldValidateOnly', 'false');
    this.uploadInProgress = true;

    this.registrationApiService.importRegistrations(this.formData)
    .subscribe({
        next: response => {
          this.uploadInProgress = false;
          this.uploadResponse = response;
          this.uploadFinished = true;
          this.canUpload = false;
        },
        error: error => {
          this.uploadInProgress = false;
          this.errors = mapImportErrors(error.error.Message, error.error.Errors);
          this.uploadResponse = error;
        }
      });
  }
}
